import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { apiClient } from "../../api/client";
import type { PublicProfile } from "../../api/types";

export function ProfilePage() {
  const { handle = "" } = useParams();
  const [profile, setProfile] = useState<PublicProfile | null>(null);

  useEffect(() => {
    if (!handle) {
      return;
    }

    void apiClient
      .get<PublicProfile>(`/users/${handle}`)
      .then((res) => setProfile(res))
      .catch(() => setProfile(null));
  }, [handle]);

  return (
    <main className="page-shell profile-page">
      <header className="page-header">
        <h1>@{handle}</h1>
      </header>
      {profile ? (
        <section className="profile-card">
          <h2 className="profile-name">{profile.display_name ?? `@${handle}`}</h2>
          <p className="profile-meta">{profile.city_code ?? "Unknown city"}</p>
          {(profile.badges ?? []).length > 0 ? (
            <div className="profile-badges" aria-label="Badges">
              {profile.badges.map((badge) => (
                <span key={badge} className="profile-badge">{badge}</span>
              ))}
            </div>
          ) : (
            <p className="profile-meta">No badges yet.</p>
          )}
        </section>
      ) : (
        <div className="empty-state">
          <p>Profile not found.</p>
        </div>
      )}
    </main>
  );
}
